import httpClient from 'shared/lib/httpClient';
import { parseMyProfile } from '../schemas/MyProfileSchema';

export const getMe = async (signal) => {
  const response = await httpClient.get('/me', { signal });
  return parseMyProfile(response?.data);
};
